<div class="unsubscribe-page">
  <div class="container">
    <div class="unsubscribe-card">
      <div class="header">
        <div class="logo-section">
          <span class="logo-icon">📧</span>
          <h1 class="logo-text">Email Preferences</h1>
        </div>
      </div>

      <div *ngIf="state.loading" class="content-section loading-section">
        <div class="status-icon loading">
          <div class="spinner"></div>
        </div>
        <h2 class="status-title">Processing Your Request</h2>
        <p class="status-message">
          Please wait while we unsubscribe you from marketing emails...
        </p>
      </div>

      <div
        *ngIf="!state.loading && state.success"
        class="content-section success-section"
      >
        <div class="status-icon success">
          <span class="icon">✅</span>
        </div>
        <h2 class="status-title">Successfully Unsubscribed</h2>
        <p class="status-message">
          {{ state.message }}
        </p>

        <div class="action-buttons">
          <button class="btn btn-primary" (click)="goToHome()">
            <span class="btn-icon">🏠</span>
            Back to Homepage
          </button>
        </div>
      </div>

      <div
        *ngIf="!state.loading && state.error"
        class="content-section error-section"
      >
        <div class="status-icon error">
          <span class="icon">⚠️</span>
        </div>
        <h2 class="status-title">Unsubscribe Failed</h2>
        <p class="status-message">
          {{ state.error }}
        </p>

        <div class="info-box error">
          <div class="info-content">
            <h3>What you can do:</h3>
            <ul>
              <li>Try the unsubscribe process again</li>
              <li>Contact our support team for assistance</li>
              <li>Update your preferences in your account settings</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
